import styled from 'styled-components';

export const StyledScrollView = styled.div`
  max-height: ${({ mh }) => mh ?? '600px'};
  overflow: auto;
`;